import ruleBuilderLayoutDocsData from "../../../../docs-data/RuleBuilderLayout.docs.json";
import ruleDetailDocsData from "../../../../docs-data/RuleDetail.docs.json";
import ruleBuilderStepsDocsData from "../../../../docs-data/RuleBuilderSteps.docs.json";
import ruleItemDocsData from "../../../../docs-data/RuleItem.docs.json";
import ruleTransitionDocsData from "../../../../docs-data/RuleTransition.docs.json";
import * as React from 'react';
export default {
  ruleBuilderLayoutDocsData,
  ruleDetailDocsData,
  ruleBuilderStepsDocsData,
  ruleItemDocsData,
  ruleTransitionDocsData,
  React
};